// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__RGfkg","addWidgetButton":"Header_addWidgetButton__2ti3I","dashboardTabs":"Header_dashboardTabs__15Mej","active":"Header_active__1Ldww"};